import Button from "../Button";
import Tooltip from "../../tooltip/Tooltip";
import { formatText } from "../../../_utils/textFormatter";
import noDataFound from "./assets/no-data-found.svg";
import askingQuestion from "./assets/asking-question.svg";
import "./_empty-state.scss";

/**
 * "No data" / "no access" placeholder - pure presentation, no loading logic
 * of its own (same contract as `Skeleton`). Callers decide when to render it
 * - most commonly as a `Table`'s `emptyState`, which only mounts once
 * `isLoading` is already false, so this component never needs to know about
 * loading state at all.
 */
const EmptyState = ({ title, desc, addButton, noIcon = false, noAccess = false }) => {
  return (
    <div className="empty-state">
      {!noIcon && (
        <img
          className="empty-state__illustration"
          src={noAccess ? askingQuestion : noDataFound}
          alt={noAccess ? "no access icon" : "no data found icon"}
        />
      )}
      <div className="empty-state__body">
        <h3 className="empty-state__title">{formatText(title)}</h3>
        <p className="empty-state__desc">{formatText(desc)}</p>
        {addButton && (
          <div className="empty-state__actions">
            {addButton?.title ? (
              <Tooltip content={addButton.title} position="top">
                <Button
                  variant="text"
                  onClick={addButton?.action}
                  disabled={addButton?.disabled}
                >
                  {formatText(addButton?.btnText)}
                </Button>
              </Tooltip>
            ) : (
              <Button
                variant="text"
                onClick={addButton?.action}
                disabled={addButton?.disabled}
              >
                {formatText(addButton?.btnText)}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
